import { TableRow, TableCell, IconButton, Menu, MenuItem } from "@mui/material"
import {
    MoreVertOutlined as MoreVertOutlinedIcon,
    VisibilityOutlined as VisibilityOutlinedIcon,
} from '@mui/icons-material'
import { useState } from "react"
import { ReserveClubhouseRequestData } from "../../clients"

interface MyClubhouseReservationRequestsRowProps {
    request: ReserveClubhouseRequestData
    handleViewRequest: (request: ReserveClubhouseRequestData) => void
}

export const MyClubhouseReservationRequestsRow = ({ request, handleViewRequest }: MyClubhouseReservationRequestsRowProps) => {

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

    const handleOpenMoreMenu = (e: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(e.currentTarget)
    }

    const handleCloseMoreMenu = () => {
        setAnchorEl(null)
    }

    const onViewRequest = () => {
        setAnchorEl(null)
        handleViewRequest(request)
    }

    const getFriendlyStatusName = (status: string) => {
        switch (status) {
            case 'approved':
                return 'Approved'
            case 'denied':
                return 'Denied'
            case 'pending':
                return 'Pending'
            default:
                return 'Unknown'
        }
    }

    return (
        <TableRow>
            <TableCell>
                {request.reserveClubhouseRequestBeginDate.toLocaleDateString(undefined, {
                    weekday: 'short',
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                })} - {request.reserveClubhouseRequestEndDate.toLocaleDateString(undefined, {
                    weekday: 'short',
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                })}
            </TableCell>
            <TableCell>
                {request.reserveClubhouseRequestCreatedDate.toLocaleDateString(undefined, {
                    weekday: 'short',
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                })}
            </TableCell>
            <TableCell>{getFriendlyStatusName(request.reserveClubhouseRequestStatus)}</TableCell>
            <TableCell sx={{ display: 'flex', justifyContent: 'end' }}>
                <IconButton
                    aria-label="options of clubhouse reservation request"
                    aria-controls="menu-clubhouse-reservation-request-options"
                    onClick={handleOpenMoreMenu}
                >
                    <MoreVertOutlinedIcon />
                </IconButton>
                <Menu
                    id="menu-clubhouse-reservation-request-options"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleCloseMoreMenu}
                    keepMounted
                >
                    <MenuItem onClick={onViewRequest}>
                        <VisibilityOutlinedIcon sx={{ mr: 1 }} /> View Request
                    </MenuItem>
                </Menu>
            </TableCell>
        </TableRow>
    )
}